import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const CustomerListState = Immutable.fromJS({
	customerList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: ''
});

const customerListReducer = handleActions({
	FIND_CUSTOMER_LIST: (state, { payload }) => {
		return state.merge({
			customerList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},
	CHANGE_CUSTOMER_ACTIVE_PAGE: (state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	}
}, CustomerListState);

export default customerListReducer;


// WEBPACK FOOTER //
// ./src/reducers/customerListReducer.js